import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"

function MomSysUdtWareHouse ( props ) {

    const [disableEdit, setDisableEdit] = useState(false);
    const [disableDelete, setDisableDelete] = useState(false);
    const [grid, setGrid] = useState();

    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (grid) {
                grid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.description ? item.description : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                        if(binding === "description" && data !== null) {
                            tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onInitialized = (grid) => {

        if ( grid ) {

            grid.selectionChanged.addHandler((grid, event) => {

                let item = grid.selectedItems && grid.selectedItems[0];

                if ( item ) {

                    switch ( item.wareHouseCode ) {

                        case "W000": // 작업대기창고 ( 1.LINE )
                        case "W999": // 작업출고창고 ( 1.LINE )
                        case "A000": // 입고대기창고 ( 2.STORE )
                        case "Z999": // 출고대기창고 ( 3.SHIP )
                        case "W998": // 불량제품창고 ( 4.FAILURE )

                            setDisableEdit(true);
                            setDisableDelete(true);
                            break;

                        default:

                            setDisableEdit(false);
                            setDisableDelete(false);
                            break;

                    }

                } else {

                    setDisableEdit ( true );
                    setDisableDelete ( true );

                }

            });

            grid.itemsSourceChanged.addHandler((grid, event) => {

                let item = grid.selectedItems && grid.selectedItems[0];

                if ( item ) {

                    switch ( item.wareHouseCode ) {

                        case "A000":
                        case "W000":
                        case "W998":
                        case "Z999":

                            setDisableEdit(true);
                            setDisableDelete(true);
                            break;
                            
                        default:

                            setDisableEdit(false);
                            setDisableDelete(false);
                            break;

                    }

                } else {

                    setDisableEdit ( true );
                    setDisableDelete ( true );
                    
                }
                
            });

        }

        setGrid(grid);

    }

    return <BasicCrudScreenType id="MomSysUdtWareHouse" disableEdit={disableEdit} disableDelete={disableDelete} table="MomSysUdtWareHouse" view="MomSysVwWareHouse" onInitialized={onInitialized} />;

}

export default MomSysUdtWareHouse;
